import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { estimateVersionsService } from '../services/estimateVersions.service';
import type { EstimateHeader, EstimateItem } from '../types/estimate.types';

export function useEstimateVersions(estimateId?: string) {
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey: ['estimates', 'versions', estimateId],
    queryFn: () => estimateVersionsService.getByEstimateId(estimateId!),
    enabled: !!estimateId,
  });

  const createSnapshotMutation = useMutation({
    mutationFn: (params: { estimate: EstimateHeader; items: EstimateItem[]; createdBy?: string | null; note?: string }) =>
      estimateVersionsService.createSnapshot(params),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['estimates', 'versions', estimateId] });
    },
  });

  return {
    versions: query.data || [],
    isLoading: query.isLoading,
    error: query.error as Error | null,
    createSnapshot: createSnapshotMutation.mutateAsync,
    isCreatingSnapshot: createSnapshotMutation.isPending,
  };
}
